import { MUTED, colorFor } from "../components/charts/chartTheme";

// As perguntas agrupadas pelo ambito, pela ordem em que o backend as manda (D2 do plano do item 14): uma
// pergunta de ambito diferente da anterior abre um grupo novo, e nada se reordena aqui. Uma pergunta que ja
// nao esta na configuracao fica num grupo so seu, para nao entrar no funil de uma pergunta que existe.
export const choiceGroups = (questions) => {
  const groups = [];
  questions.forEach((question) => {
    const last = groups[groups.length - 1];
    if (last && last.scope === question.scope && question.configured && last.questions[0].configured) last.questions.push(question);
    else groups.push({ scope: question.scope, questions: [question] });
  });
  return groups;
};

// O que se fez com cada vez que a pergunta se fez, pela ordem da barra. As posicoes da paleta sao as das tres
// partes da `composition`; as conversas ainda abertas, que nao sao uma resposta, ficam a cinzento no fim.
const ANSWERS = ["tapped", "typed_reply", "no_reply", "open"];
const SLOTS = { tapped: 1, typed_reply: 3, no_reply: 2 };

// Os quatro segmentos da barra com o valor, ou `null` numa pergunta que nunca se fez. Quem os desenha
// formata a parte sobre `asked`.
export const answerSegments = (question, translate) => {
  if (question.asked === 0) return null;
  return ANSWERS.map((key) => ({
    key,
    value: question[key],
    label: translate(`analyticsChoicesAnswer.${key}`),
    color: key === "open" ? MUTED : colorFor(SLOTS, key),
  }));
};

// As linhas das opcoes tocadas para o RankedBars: todas as da pergunta, as nunca escolhidas a zero, pelo id e com
// o nome tal como vem da config (sem `translate`, para duas opcoes com o mesmo nome nao se juntarem). Vao por
// tocadas descendente e, em empate, pela ordem da config. O que se tocou sem se identificar a opcao
// (`unknown_option`) fica no fim, a cinzento, para as partes somarem os tocados.
export const optionRows = (question, translate) => {
  const rows = question.options
    .map((option) => ({
      key: option.id,
      value: option.chosen,
      label: option.configured ? option.label : `${option.label} (${translate("analyticsCardNoLongerConfigured")})`,
      muted: false,
    }))
    .sort((a, b) => b.value - a.value);
  if (question.unknown_option > 0) {
    rows.push({ key: "unattributed", value: question.unknown_option, label: translate("analyticsChoicesUnknownOption"), muted: true });
  }
  return rows;
};
